import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgKeyResult = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path fill={_.color} d="M3 8h2.143v5H3zm4-3h2v8H7zm4-3h2v11h-2z" />
  </svg>
);
const ForwardRef = forwardRef(SvgKeyResult);
export default ForwardRef;
